module.exports = __webpack_public_path__ + "img/icon24.60187955.svg";